import { useRef } from "react";

export function visitedPageKey(parts) {
  return parts.map((part) => String(part ?? "")).join("|");
}

/** Stable cache for list pages already loaded in this screen. */
export function useVisitedPageCache() {
  const cacheRef = useRef(new Map());
  const apiRef = useRef(null);
  if (!apiRef.current) {
    apiRef.current = {
      read(key) {
        return cacheRef.current.has(key) ? cacheRef.current.get(key) : null;
      },
      write(key, snapshot) {
        if (!key) return;
        cacheRef.current.set(key, snapshot);
      },
      clear() {
        cacheRef.current.clear();
      },
    };
  }
  return apiRef.current;
}
